import Header from "./components/_components/header";
import Services from "./components/_components/services";
import Process from "./components/_components/process";
import Automation from "./components/_components/аutomation";
import Contact from "./components/_components/contact";
import Footer from "./components/_components/footer";

function App() {
  return (
    <>
      <Header />
      <Automation />
      <Services />
      <Process />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
